"use strict";

exports.__esModule = true;
exports.fourDotsClass = exports.threeBounceClass = exports.scaleCircleClass = exports.chasingRingClass = exports.cubeGridClass = exports.doubleBounceClass = exports.chasingDotsClass = exports.waveClass = exports.pulseClass = exports.planeClass = exports.ringClass = exports.defaultClass = void 0;

var _classname = _interopRequireDefault(require("../utils/classname"));

var _default = _interopRequireDefault(require("./spin/default.less"));

var _ring = _interopRequireDefault(require("./spin/ring.less"));

var _plane = _interopRequireDefault(require("./spin/plane.less"));

var _pulse = _interopRequireDefault(require("./spin/pulse.less"));

var _wave = _interopRequireDefault(require("./spin/wave.less"));

var _chasingDots = _interopRequireDefault(require("./spin/chasing-dots.less"));

var _doubleBounce = _interopRequireDefault(require("./spin/double-bounce.less"));

var _cubeGrid = _interopRequireDefault(require("./spin/cube-grid.less"));

var _chasingRing = _interopRequireDefault(require("./spin/chasing-ring.less"));

var _scaleCircle = _interopRequireDefault(require("./spin/scale-circle.less"));

var _threeBounce = _interopRequireDefault(require("./spin/three-bounce.less"));

var _fourDots = _interopRequireDefault(require("./spin/four-dots.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Created by scripts/create-style.js.
var defaultClass = (0, _classname.default)(_default.default, 'spin-default');
exports.defaultClass = defaultClass;
var ringClass = (0, _classname.default)(_ring.default, 'spin-ring');
exports.ringClass = ringClass;
var planeClass = (0, _classname.default)(_plane.default, 'spin-plane');
exports.planeClass = planeClass;
var pulseClass = (0, _classname.default)(_pulse.default, 'spin-pulse');
exports.pulseClass = pulseClass;
var waveClass = (0, _classname.default)(_wave.default, 'spin-wave');
exports.waveClass = waveClass;
var chasingDotsClass = (0, _classname.default)(_chasingDots.default, 'chasing-dots');
exports.chasingDotsClass = chasingDotsClass;
var doubleBounceClass = (0, _classname.default)(_doubleBounce.default, 'double-bounce');
exports.doubleBounceClass = doubleBounceClass;
var cubeGridClass = (0, _classname.default)(_cubeGrid.default, 'cube-grid');
exports.cubeGridClass = cubeGridClass;
var chasingRingClass = (0, _classname.default)(_chasingRing.default, 'chasing-ring');
exports.chasingRingClass = chasingRingClass;
var scaleCircleClass = (0, _classname.default)(_scaleCircle.default, 'scale-circle');
exports.scaleCircleClass = scaleCircleClass;
var threeBounceClass = (0, _classname.default)(_threeBounce.default, 'three-bounce');
exports.threeBounceClass = threeBounceClass;
var fourDotsClass = (0, _classname.default)(_fourDots.default, 'four-dots');
exports.fourDotsClass = fourDotsClass;